"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("indicateurService", function ($http, chartUtils, tlColors) {
  return {
    getAll: function getAll() {
      return $http.get('/rest/indicateurs/list').then(function (response) {
        return response.data;
      });
    },
    /**
     * creation de la serie
     * @param config
     * @param data IndicateurResultDTO
     * @param yAttribute valeur par défaut
     * @param pointCreationFct mapping spécifique des points
     */
    createConfigSeries: function createConfigSeries(config, data, yAttribute, pointCreationFct) {
      if (yAttribute === undefined) {
        yAttribute = "valeur";
      }
      config.series = [{
        name: data.nom + (data.avecSimulations ? " (portefeuille)" : ""),
        data: chartUtils.mapAndFilter(data.valeursPortefeuille, "date", yAttribute, pointCreationFct),
        color: tlColors.NEW_BLUE_1
      }];
      if (data.avecSimulations) {
        config.series.push({
          name: data.nom + " (avec impact des simulations)",
          data: chartUtils.mapAndFilter(data.valeurs, "date", yAttribute, pointCreationFct),
          color: tlColors.FUSCHIA
        });
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/indicateurService.js
// module id = 2875
// module chunks = 13